import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';

export const PosthogFlagsReloader = () => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') posthog.reloadFeatureFlags();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [posthog]);

  return null;
};
